var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { components } from 'react-select';
import AsyncSelect from 'react-select/async';
import { ThemeConsumer } from 'styled-components';
import { customStyles } from './ImgSelect';
var ImgAsyncSelect = /** @class */ (function (_super) {
    __extends(ImgAsyncSelect, _super);
    function ImgAsyncSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.MultiValueLabel = function (props) {
            var data = props.data;
            //console.log("MultiValueLabel", data);
            return React.createElement(React.Fragment, null, _this.props.changeMultiValue ? _this.props.changeMultiValue(data) : "");
        };
        _this.SingleValue = function (props) {
            var data = props.data;
            //console.log("SingleValue ", data);
            return React.createElement(React.Fragment, null, _this.props.changeSingleValue ? _this.props.changeSingleValue(data) : "");
        };
        _this.Option = function (props) {
            var data = props.data;
            //console.log("option ", data);
            return React.createElement(components.Option, __assign({}, props), _this.props.changeOption ? _this.props.changeOption(data) : React.createElement(React.Fragment, null));
        };
        _this.create = function (theme) {
            return customStyles(theme);
        };
        _this.state = {};
        return _this;
    }
    ImgAsyncSelect.prototype.render = function () {
        var _this = this;
        return (React.createElement(ThemeConsumer, null, function (theme) {
            return React.createElement(AsyncSelect, __assign({ styles: _this.create(theme), components: {
                    Option: _this.props.changeOption ? _this.Option : undefined,
                    SingleValue: _this.props.changeSingleValue ? _this.SingleValue : undefined,
                    MultiValueLabel: _this.props.changeMultiValue ? _this.MultiValueLabel : undefined,
                } }, _this.props));
        }));
    };
    return ImgAsyncSelect;
}(React.PureComponent));
export default ImgAsyncSelect;
//# sourceMappingURL=ImgAsyncSelect.js.map